import React from "react";
import { Helmet } from "react-helmet-async";
const AddSeo = ({
  title = "Elam Travels Trichy | Car Rentals, Tour Packages, and Travel Agency in Trichy",
  description = "Elam Travels in Trichy offers affordable car rentals, outstation taxis, and cabs for hire. Choose from budget-friendly 4 to 7-seater options, including Maruti Swift Dzire, Toyota Etios, and Innova Crysta, tailored to your travel needs. Book now for reliable and comfortable rides!",
  keywords = "Elam Travels, Travels in Trichy, Car Rentals in Trichy, Outstation Taxi Trichy, Trichy Airport Taxi, Tempo Traveller Trichy, Tour Packages Trichy, Travel Agency in Trichy, Trichy Tours and Travels, Affordable Car Rentals, Family Tour Packages Trichy, Tirupati Tour Package Trichy, Kerala Tour Package Trichy, Honeymoon Packages Trichy, Best Travel Agency Trichy, South India Travel Packages, Budget Car Rentals Trichy, Online Car Booking Trichy, Innova Rental Trichy, Etios Rental Trichy",
}) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    url: window.location.href,
    description: description,
  };
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={window.location.href} />
      <link rel="alternate" href={window.location.href} hreflang="en-IN" />
      <script type="application/ld+json" data-schema="true">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default AddSeo;
